// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c262b1e1","239":"080d257a","453":"619b0fdf","455":"2e0a82eb"}[chunkId] + ".chunk.js";
};